import React, { useState, useEffect } from "react";
import { FiShare2,FiEdit2 } from "react-icons/fi";
import { BiSearch } from "react-icons/bi";
import { getMeetingSessionById, updateMeetingSessionName } from "../../services/meetingServices";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateCustomMeetingName } from "../../services/meetingServices";
const AINotetaker = () => {
  const [activeTab, setActiveTab] = useState("summary");
  const { sessionId } = useParams();
  const [meetingData, setMeetingData] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [isSavingName, setIsSavingName] = useState(false);

  useEffect(() => {
    const fetchSession = async () => {
      const response = await getMeetingSessionById(sessionId);
      console.log(response);
      setMeetingData(response.data);
    };
    fetchSession();
  }, [sessionId]);

  const handleEditName = () => {
    const currentName =
      meetingData?.custom_session_name ||
      meetingData?.sessionId ||
      meetingData?.meetingName ||
      "";
    setEditedName(currentName);
    setIsEditingName(true);
  };

  const handleCancelEdit = () => {
    setIsEditingName(false);
    setEditedName("");
  };

  const handleSaveName = async () => {
    if (!editedName.trim()) {
      toast.error("Meeting name cannot be empty");
      return;
    }

    setIsSavingName(true);
    try {
      await updateMeetingSessionName({
        sessionId: sessionId,
        custom_session_name: editedName.trim(),
      });

      // Update local state
      setMeetingData((prev) => ({
        ...prev,
        custom_session_name: editedName.trim(),
      }));

      setIsEditingName(false);
      toast.success("Meeting name updated successfully");
    } catch (error) {
      console.error("Error updating meeting name:", error);
      toast.error("Failed to update meeting name. Please try again.");
    } finally {
      setIsSavingName(false);
    }
  };

  // Format date to "Oct 27, 2025" format
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${
      months[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  };

  // Format duration to "1h 12m" format
  const formatDuration = (durationString) => {
    if (!durationString) return "-";
    // If duration is already in format like "1h 12m", return as is
    if (typeof durationString === "string" && durationString.includes("h")) {
      return durationString;
    }
    // If duration is in minutes, convert to hours and minutes
    if (typeof durationString === "number") {
      const hours = Math.floor(durationString / 60);
      const minutes = durationString % 60;
      return `${hours}h ${minutes}m`;
    }
    // If duration is in milliseconds or seconds, convert
    if (typeof durationString === "number" && durationString > 3600) {
      const totalMinutes = Math.floor(durationString / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}m`;
    }
    return durationString;
  };

  // Format participants to "X attendees (Y on stage)" format
  const formatParticipants = (participants) => {
    if (!participants) return "-";
    const total = participants.length;
    // For now, we'll assume 4 on stage if not provided
    const onStage = 4; // This could come from the API if available
    // return `${total} attendees (${onStage} on stage)`;
    return `${total} attendees`;
  };
  // const meetingData = {
  //   title: "Marketing Session #3",
  //   date: "Oct 27, 2025",
  //   duration: "1h 12m",
  //   attendees: "Participants: 38 attendees (4 on stage)",
  //   recording: "[Watch Replay]",
  //   language: "English + Spanish",
  // };

  const mentions = [
    {
      name: "Emily R.",
      items: [
        '"Emily, please send the updated deck to the client by Thursday." (Task)',
        '"Can Emily handle the follow-up email sequence?" (Task)',
        '"Emily\'s version of the slides looked great." (Comment)',
      ],
    },
    {
      name: "Daniel W.",
      items: [
        '"Daniel, create the analytics dashboard for next week." (Task)',
        '"Daniel\'s prototype reduced load time by 40%." (Reference)',
      ],
    },
    {
      name: "Sarah J.",
      items: [
        '"Sarah will review client feedback forms." (Task)',
        '"Ask Sarah if the video is already uploaded." (Follow-up)',
      ],
    },
  ];

  return (
    <div className="min-h-screen flex items-start justify-center p-2 sm:p-3 md:p-6 overflow-x-hidden">
      <div className="w-full max-w-5xl overflow-x-hidden">
        <div className="rounded-xl p-3 sm:p-4 md:p-6 lg:p-8 primary-card-background overflow-x-hidden">
          {/* Top metadata bar */}
          <div className="bg-transparent text-white mb-4 md:mb-6">
            {/* Centered Title */}
            <div className="flex justify-center mb-3 sm:mb-4 md:mb-6">
              <h1 className="text-white font-poppins text-sm sm:text-base md:text-lg lg:text-2xl tracking-widest">
                AI TRANSCRIPT
              </h1>
            </div>

            {/* Two Column Layout */}
            <div className="grid grid-cols-2 gap-x-2 sm:gap-x-4 md:gap-x-24 lg:gap-x-40 xl:gap-x-48 gap-y-2 sm:gap-y-3 md:gap-y-4 text-xs sm:text-sm md:text-base">
              {/* Left Column */}
              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <div className="flex flex-col gap-0.5 sm:gap-1">
                  <div className="flex items-center gap-2">
                    <span className="text-gray-300 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">
                      Meeting Name:
                    </span>
                    {!isEditingName && meetingData && (
                      <button
                        onClick={handleEditName}
                        className="text-white bg-primaryPurple p-1 rounded hover:text-white transition-colors"
                        title="Edit meeting name"
                      >
                        <FiEdit2 className="w-3 h-3 sm:w-4 sm:h-4" />
                      </button>
                    )}
                  </div>
                  {isEditingName ? (
                    <div className="flex flex-col gap-2">
                      <input
                        type="text"
                        value={editedName}
                        onChange={(e) => setEditedName(e.target.value)}
                        className="bg-gray-800 text-white font-bold text-xs sm:text-sm md:text-base px-2 py-1 rounded border border-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500 min-w-0"
                        placeholder="Enter meeting name"
                        disabled={isSavingName}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSaveName();
                          } else if (e.key === "Escape") {
                            handleCancelEdit();
                          }
                        }}
                        autoFocus
                      />
                      <div className="flex gap-2">
                        <button
                          onClick={handleSaveName}
                          disabled={isSavingName}
                          className="px-2 py-1 bg-primaryPurple hover:bg-primaryPurple/80 text-white text-xs rounded transition disabled:bg-primaryPurple/40 disabled:cursor-not-allowed"
                        >
                          {isSavingName ? "Saving..." : "Save"}
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          disabled={isSavingName}
                          className="px-2 py-1 bg-gray-600 hover:bg-gray-700 text-white text-xs rounded transition disabled:bg-gray-500 disabled:cursor-not-allowed"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <span className="text-white font-bold text-xs sm:text-sm md:text-base break-all sm:break-words md:truncate min-w-0">
                      {meetingData
                        ? meetingData.custom_session_name ||
                          meetingData.sessionId ||
                          meetingData.meetingName ||
                          "-"
                        : "-"}
                    </span>
                  )}
                </div>
                <div className="flex flex-col gap-0.5 sm:gap-1">
                  <span className="text-gray-300 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">
                    Date:
                  </span>
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base">
                    {meetingData
                      ? formatDate(
                          meetingData.startDate ||
                            meetingData.scheduledStartTime ||
                            meetingData.date
                        )
                      : "-"}
                  </span>
                </div>
                <div className="flex flex-col gap-0.5 sm:gap-1">
                  <span className="text-gray-300 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">
                    Duration:
                  </span>
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base">
                    {meetingData ? formatDuration(meetingData.duration) : "-"}
                  </span>
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <div className="flex flex-col gap-0.5 sm:gap-1">
                  <span className="text-gray-300 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">
                    Participants:
                  </span>
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base">
                    {meetingData
                      ? formatParticipants(meetingData.participants)
                      : "-"}
                  </span>
                </div>
                <div className="flex flex-col gap-0.5 sm:gap-1">
                  <span className="text-gray-300 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">
                    Recording:
                  </span>
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base">
                    {meetingData &&
                    (meetingData.recordingUrl || meetingData.recording) ? (
                      <button
                        onClick={() => {
                          const url =
                            meetingData.recordingUrl || meetingData.recording;
                          if (url) {
                            window.open(url, "_blank");
                          }
                        }}
                        className="text-white hover:underline text-xs sm:text-sm md:text-base break-words sm:break-normal"
                      >
                        [Watch Replay]
                      </button>
                    ) : (
                      "-"
                    )}
                  </span>
                </div>
                <div className="flex flex-col gap-0.5 sm:gap-1">
                  <span className="text-gray-300 text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">
                    Language detected:
                  </span>
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base">
                    {meetingData
                      ? meetingData.language || meetingData.languages || "-"
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Top Tabs */}
          <div className="w-full mb-3 sm:mb-4 md:mb-6">
            <div className="flex flex-wrap gap-2 md:gap-3 md:flex-nowrap">
              {[
                { key: "summary", label: "AI Summary" },
                { key: "transcript", label: "Full Transcript" },
                { key: "decisions", label: "Key Decisions" },
                { key: "actions", label: "Action Items" },
                { key: "mentions", label: "Mentions" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-3 sm:px-3 md:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-xs md:text-sm font-poppins tracking-wide transition whitespace-nowrap ${
                    activeTab === tab.key
                      ? "bg-[#7700FF] text-white"
                      : "bg-gray-800 text-gray-200 hover:bg-gray-700"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Search row */}
          {/* <div className="flex items-center gap-3 mb-6">
            <div className="flex-1 relative">
              <input
                type="text"
                placeholder='Type a name or word (e.g. "John", "budget", "timeline")'
                className="w-full bg-white/90 text-gray-700 placeholder-gray-500 font-montserrat text-sm px-4 py-3 rounded-lg focus:outline-none"
              />
              <BiSearch className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 w-5 h-5" />
            </div>
            <button className="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg font-poppins">
              Search
            </button>
          </div> */}

          {/* Content area */}
          <div className="overflow-x-hidden">
            {activeTab === "summary" && (
              <div className="bg-white rounded-lg p-3 sm:p-4 md:p-6 overflow-x-hidden">
                <h3 className="text-black font-montserrat text-sm sm:text-base md:text-lg font-bold mb-2 sm:mb-3 md:mb-4 break-words">
                  AI Summary
                </h3>
                <ul className="space-y-2 text-xs sm:text-xs md:text-sm text-gray-800 overflow-x-hidden">
                  {meetingData?.aisummary ? (
                    <div className="prose prose-sm max-w-none break-words overflow-x-hidden">
                      {meetingData.aisummary.split(/\r?\n/).map((line, idx) =>
                        line.trim() === "" ? (
                          <br key={idx} />
                        ) : (
                          <span key={idx} className="break-words">
                            {line}
                            <br />
                          </span>
                        )
                      )}
                    </div>
                  ) : (
                    <li className="text-gray-500">No AI summary available.</li>
                  )}
                </ul>
              </div>
            )}
            {activeTab === "transcript" && (
              <div className="bg-white rounded-lg p-3 sm:p-4 md:p-6 overflow-x-hidden">
                <h3 className="text-black font-montserrat text-sm sm:text-base md:text-lg font-bold mb-2 sm:mb-3 md:mb-4 break-words">
                  Full Transcript
                </h3>
                <p className="text-gray-800 text-xs sm:text-xs md:text-sm break-words overflow-x-hidden">
                  {/* Placeholder for transcript text */}
                  {meetingData?.fulltranscript ? (
                    meetingData.fulltranscript.split(/\r?\n/).map((line, idx) =>
                      line.trim() === "" ? (
                        <br key={idx} />
                      ) : (
                        <span key={idx} className="break-words">
                          {line}
                          <br />
                        </span>
                      )
                    )
                  ) : (
                    <span className="text-gray-500">
                      No transcript available.
                    </span>
                  )}
                </p>
              </div>
            )}
            {activeTab === "decisions" && (
              <div className="bg-white rounded-lg p-3 sm:p-4 md:p-6 overflow-x-hidden">
                <h3 className="text-black font-montserrat text-sm sm:text-base md:text-lg font-bold mb-2 sm:mb-3 md:mb-4 break-words">
                  Key Decisions
                </h3>
                <ul className="space-y-2 text-xs sm:text-xs md:text-sm text-gray-800 overflow-x-hidden">
                  {meetingData?.keydecisions &&
                  typeof meetingData.keydecisions === "string" &&
                  meetingData.keydecisions.trim() !== "" ? (
                    meetingData.keydecisions
                      .split(/\r?\n/)
                      .map((line, idx, arr) =>
                        line.trim() === "" && arr.length > 1 ? (
                          <br key={idx} />
                        ) : (
                          <li key={idx} className="break-words">
                            {line}
                          </li>
                        )
                      )
                  ) : (
                    <li className="text-gray-500">
                      No key decisions available.
                    </li>
                  )}
                </ul>
              </div>
            )}
            {activeTab === "actions" && (
              <div className="bg-white rounded-lg p-3 sm:p-4 md:p-6 overflow-x-hidden">
                <h3 className="text-black font-montserrat text-sm sm:text-base md:text-lg font-bold mb-2 sm:mb-3 md:mb-4 break-words">
                  Action Items
                </h3>
                <ul className="space-y-2 text-xs sm:text-xs md:text-sm text-gray-800 overflow-x-hidden">
                  {meetingData?.actionitems &&
                  typeof meetingData.actionitems === "string" &&
                  meetingData.actionitems.trim() !== "" ? (
                    meetingData.actionitems
                      .split(/\r?\n/)
                      .filter((line) => line.trim() !== "")
                      .map((action, idx) => (
                        <li key={idx} className="break-words">
                          {action}
                        </li>
                      ))
                  ) : (
                    <li className="text-gray-500">
                      No action items available.
                    </li>
                  )}
                </ul>
              </div>
            )}
            {activeTab === "mentions" && (
              <div className="relative overflow-x-hidden">
                {/* <div className="flex justify-end mb-2 text-xs text-gray-300 gap-4">
                  <button className="hover:underline">COPY MENTIONS</button>
                  <button className="hover:underline">TRANSLATE</button>
                </div> */}
                <div className="bg-white rounded-lg p-3 sm:p-4 md:p-6 shadow-lg overflow-x-hidden">
                  <h3 className="text-black font-montserrat text-sm sm:text-base md:text-lg font-bold mb-2 sm:mb-3 md:mb-4 break-words">
                    Mentions
                  </h3>
                  <div className="space-y-3 sm:space-y-4 md:space-y-5 overflow-x-hidden">
                    {meetingData?.mentions &&
                    typeof meetingData.mentions === "string" &&
                    meetingData.mentions.trim() !== "" ? (
                      meetingData.mentions
                        .split(/\r?\n/)
                        .filter((line) => line.trim() !== "")
                        .map((line, idx) => (
                          <div key={idx} className="overflow-x-hidden">
                            <div className="flex items-start sm:items-center gap-2 md:gap-3 mb-2 min-w-0">
                              <div className="w-6 h-6 md:w-7 md:h-7 bg-gray-200 rounded-full flex items-center justify-center text-xs md:text-sm font-bold text-gray-700 flex-shrink-0 mt-0.5 sm:mt-0">
                                {line.trim()[0]}
                              </div>
                              <div className="text-black font-montserrat font-semibold text-xs sm:text-xs md:text-sm break-words flex-1 min-w-0">
                                {line}
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="text-gray-500 text-xs sm:text-xs md:text-sm">
                        No mentions available.
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-2 sm:mt-2 md:mt-3 text-xs text-gray-300 break-words">
                  AI-generated insights. Please verify key data and assignments
                  before distribution.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AINotetaker;
